import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Requests() {
  const { accent, accentBg } = useBrandColors()
  const [activeTab, setActiveTab] = useState('my-tickets')
  const [requestType, setRequestType] = useState('IT')
  const [submitted, setSubmitted] = useState(false)
  const [form, setForm] = useState({
    category: '', subject: '', description: '', priority: 'Medium',
    fundingSource: '', approvedBy: '', additionalNotes: '',
  })
  const [equipment, setEquipment] = useState({
    standardLaptop: false, standardMac: false, standardWindows: false,
    highEndLaptop: false, highEndMac: false, highEndWindows: false,
    keyboardMouse: false, keyboardMac: false, keyboardWindows: false,
    webcam: false,
    cable: false, cableType: '',
    charger: false, chargerType: '',
    dockingStation: false, dockingMac: false, dockingWindows: false,
    externalStorage: false, usbFlash: false, usbHardDrive: false,
    monitor: false, monitorStandard: false, monitorLarge: false,
    software: false, softwareType: '',
    other: false, otherType: '',
  })

  const myTickets = [
    { id: 'IT-002', type: 'IT', subject: 'Replacement keyboard', category: 'Equipment Request', status: 'Open', priority: 'Low', created: 'Apr 1, 2025',
      messages: [{ author: 'IT Support', text: 'We have received your request and will process it shortly. IT will reach out to you directly within 3 business days.', time: 'Apr 1, 3:00pm', type: 'reply' }] },
    { id: 'FAC-003', type: 'Facilities', subject: 'Office supplies restock', category: 'Supplies', status: 'Pending', priority: 'Low', created: 'Mar 30, 2025', messages: [] },
  ]

  const itCategories = ['Hardware Issue', 'Software Issue', 'Equipment Request', 'Network / Connectivity', 'Account / Access', 'New Employee Setup', 'Other']
  const facCategories = ['Building Access', 'Maintenance', 'Supplies', 'Workspace', 'Safety', 'Cleaning', 'Other']

  const priorityColor = { Urgent:'#A0392B', High:'#C4843A', Medium:'#4A6B8A', Low:'#6B7D6B' }
  const statusColor   = { Open:'#C4843A', 'In Progress':'#4A6B8A', Pending:'#8A6A2A', Resolved:'#4A7C59', Closed:'#8A9E8A' }

  const isEquipment = form.category === 'Equipment Request'

  const tog = (field) => setEquipment(e => ({...e, [field]: !e[field]}))

  function buildItemsList() {
    const items = []
    if (equipment.standardLaptop) {
      const os = equipment.standardMac && equipment.standardWindows ? 'Mac & Windows' : equipment.standardMac ? 'Mac' : equipment.standardWindows ? 'Windows' : ''
      items.push('Standard Laptop ($499-$899)' + (os ? ' - ' + os : ''))
    }
    if (equipment.highEndLaptop) {
      const os = equipment.highEndMac && equipment.highEndWindows ? 'Mac & Windows' : equipment.highEndMac ? 'Mac' : equipment.highEndWindows ? 'Windows' : ''
      items.push('High-End Laptop ($1,200+)' + (os ? ' - ' + os : ''))
    }
    if (equipment.keyboardMouse) {
      const os = equipment.keyboardMac && equipment.keyboardWindows ? 'Mac & Windows' : equipment.keyboardMac ? 'Mac' : equipment.keyboardWindows ? 'Windows' : ''
      items.push('Keyboard/Mouse' + (os ? ' - ' + os : ''))
    }
    if (equipment.webcam) items.push('Webcam')
    if (equipment.cable) items.push('Cable' + (equipment.cableType ? ' - ' + equipment.cableType : ''))
    if (equipment.charger) items.push('Charger' + (equipment.chargerType ? ' - ' + equipment.chargerType : ''))
    if (equipment.dockingStation) {
      const os = equipment.dockingMac && equipment.dockingWindows ? 'Mac & Windows' : equipment.dockingMac ? 'Mac' : equipment.dockingWindows ? 'Windows' : ''
      items.push('Docking Station' + (os ? ' - ' + os : ''))
    }
    if (equipment.externalStorage) {
      if (equipment.usbFlash) items.push('USB Flash Drive')
      if (equipment.usbHardDrive) items.push('USB External Hard Drive')
      if (!equipment.usbFlash && !equipment.usbHardDrive) items.push('External Storage')
    }
    if (equipment.monitor) {
      const size = equipment.monitorStandard && equipment.monitorLarge ? 'Standard & Large' : equipment.monitorStandard ? 'Standard' : equipment.monitorLarge ? 'Large' : ''
      items.push('Monitor' + (size ? ' - ' + size : ''))
    }
    if (equipment.software) items.push('Software' + (equipment.softwareType ? ' - ' + equipment.softwareType : ''))
    if (equipment.other) items.push('Other' + (equipment.otherType ? ' - ' + equipment.otherType : ''))
    return items
  }

  function handleSubmit() {
    if (!form.category || !form.subject || !form.description) { alert('Please fill in all required fields.'); return }
    if (isEquipment && !form.fundingSource) { alert('Funding Source is required for equipment requests.'); return }
    if (isEquipment && !form.approvedBy) { alert('Approved By is required for equipment requests.'); return }
    setSubmitted(true)
    setTimeout(() => {
      setSubmitted(false)
      setForm({ category:'', subject:'', description:'', priority:'Medium', fundingSource:'', approvedBy:'', additionalNotes:'' })
      setEquipment({ standardLaptop:false, standardMac:false, standardWindows:false, highEndLaptop:false, highEndMac:false, highEndWindows:false, keyboardMouse:false, keyboardMac:false, keyboardWindows:false, webcam:false, cable:false, cableType:'', charger:false, chargerType:'', dockingStation:false, dockingMac:false, dockingWindows:false, externalStorage:false, usbFlash:false, usbHardDrive:false, monitor:false, monitorStandard:false, monitorLarge:false, software:false, softwareType:'', other:false, otherType:'' })
      setActiveTab('my-tickets')
    }, 4000)
  }

  const inputStyle = { width:'100%', padding:'8px 12px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:9, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }
  const checkRow = (field, label, children) => (
    <div style={{marginBottom:6}}>
      <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:12,color:'#2B2B2B',fontWeight:500}}>
        <input type="checkbox" checked={equipment[field]} onChange={()=>tog(field)} style={{accentColor:accent,width:14,height:14,flexShrink:0}}/>
        {label}
      </label>
      {equipment[field] && children && <div style={{marginLeft:26,marginTop:4}}>{children}</div>}
    </div>
  )
  const subCheck = (field, label) => (
    <label key={field} style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer',fontSize:11,color:'#6B7D6B',marginBottom:3}}>
      <input type="checkbox" checked={equipment[field]} onChange={()=>tog(field)} style={{accentColor:accent,width:12,height:12}}/>
      {label}
    </label>
  )
  const specifyInput = (field, placeholder) => (
    <input value={equipment[field]} onChange={e=>setEquipment(eq=>({...eq,[field]:e.target.value}))} placeholder={placeholder}
      style={{...inputStyle, fontSize:11, padding:'5px 8px', marginTop:4}}/>
  )

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20}}>
        <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Requests</h1>
        <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Submit IT and Facilities requests or check your ticket status</p>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {[['my-tickets','My Tickets'],['new','New Request']].map(([key,label],i,arr)=>(
          <button key={key} onClick={()=>setActiveTab(key)}
            style={{padding:'8px 24px',border:'none',borderRight:i<arr.length-1?'1px solid #EDE6DA':'none',background:activeTab===key?accent:'#fff',color:activeTab===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
            {label}
            {key==='my-tickets' && myTickets.filter(t=>t.status==='Open').length > 0 && (
              <span style={{marginLeft:6,background:activeTab===key?'rgba(255,255,255,0.3)':accent,color:'#fff',fontSize:9,padding:'1px 5px',borderRadius:8,fontWeight:600}}>
                {myTickets.filter(t=>t.status==='Open').length}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* My Tickets */}
      {activeTab === 'my-tickets' && (
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {myTickets.length === 0 ? (
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'40px',textAlign:'center'}}>
              <div style={{fontSize:13,color:'#8A9E8A',marginBottom:12}}>No tickets submitted yet.</div>
              <button onClick={()=>setActiveTab('new')} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Submit a Request</button>
            </div>
          ) : myTickets.map(t=>(
            <div key={t.id} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px 20px'}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:5,flexWrap:'wrap'}}>
                <span style={{fontSize:11,fontWeight:700,color:'#8A9E8A'}}>{t.id}</span>
                <span style={{fontSize:10,padding:'2px 7px',borderRadius:20,fontWeight:600,background:priorityColor[t.priority]+'22',color:priorityColor[t.priority]}}>{t.priority}</span>
                <span style={{fontSize:10,padding:'2px 7px',borderRadius:20,fontWeight:600,background:statusColor[t.status]+'22',color:statusColor[t.status]}}>{t.status}</span>
                <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,background:'#F7F2EB',color:'#6B7D6B'}}>{t.category}</span>
              </div>
              <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B',marginBottom:4}}>{t.subject}</div>
              <div style={{fontSize:11,color:'#8A9E8A',marginBottom: t.messages.length>0?10:0}}>Submitted {t.created}</div>
              {t.messages.filter(m=>m.type==='reply').map((m,i)=>(
                <div key={i} style={{padding:'10px 12px',background:'#F7F2EB',borderRadius:8,borderLeft:`3px solid ${accent}`}}>
                  <div style={{fontSize:10,fontWeight:600,color:accent,marginBottom:3}}>Update from {m.author}</div>
                  <div style={{fontSize:12,color:'#4A4A4A'}}>{m.text}</div>
                  <div style={{fontSize:10,color:'#8A9E8A',marginTop:2}}>{m.time}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* New Request */}
      {activeTab === 'new' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 280px',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>

            {/* Request type toggle */}
            <div style={{padding:'14px 20px',borderBottom:'1px solid #EDE6DA',display:'flex',gap:8,background:'#F7F2EB'}}>
              {[['IT','IT Request'],['Facilities','Facilities Request']].map(([type,label])=>(
                <button key={type} onClick={()=>{setRequestType(type);setForm(f=>({...f,category:''}))}}
                  style={{flex:1,padding:'8px',border:requestType===type?`2px solid ${accent}`:'2px solid transparent',borderRadius:6,background:requestType===type?'#fff':'transparent',color:requestType===type?accent:'#6B7D6B',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
                  {label}
                </button>
              ))}
            </div>

            {submitted ? (
              <div style={{padding:'60px 40px',textAlign:'center'}}>
                <div style={{width:56,height:56,borderRadius:'50%',background:'rgba(74,124,89,0.1)',border:'2px solid #4A7C59',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px',fontSize:24}}>✓</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:18,color:'#2B2B2B',fontWeight:600,marginBottom:8}}>Request Submitted!</div>
                <div style={{fontSize:12,color:'#6B7D6B',lineHeight:1.7}}>Your ticket has been created and IT has been notified.<br/>IT will review your request and reach out to you shortly.<br/>You can track the status in "My Tickets".</div>
              </div>
            ) : (
              <div style={{padding:'20px',display:'flex',flexDirection:'column',gap:14}}>

                {/* Category */}
                <div>
                  <label style={labelStyle}>Category *</label>
                  <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={inputStyle}>
                    <option value="">Select a category...</option>
                    {(requestType==='IT'?itCategories:facCategories).map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>

                {/* MDIBL Equipment Form */}
                {isEquipment && requestType==='IT' && (
                  <div style={{background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,padding:'16px'}}>
                    <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B',marginBottom:14}}>Equipment Selection</div>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 24px'}}>
                      <div>
                        <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Computer Type</div>
                        {checkRow('standardLaptop','Standard Laptop ($499-$899)',
                          <>{subCheck('standardMac','Mac')}{subCheck('standardWindows','Windows')}</>
                        )}
                        {checkRow('highEndLaptop','High-End Laptop ($1,200+)',
                          <>{subCheck('highEndMac','Mac')}{subCheck('highEndWindows','Windows')}</>
                        )}
                      </div>
                      <div>
                        <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Accessory Type</div>
                        {checkRow('keyboardMouse','Keyboard/Mouse',
                          <>{subCheck('keyboardMac','Mac')}{subCheck('keyboardWindows','Windows')}</>
                        )}
                        {checkRow('webcam','Webcam')}
                        {checkRow('cable','Cable (Specify Type)',
                          specifyInput('cableType','e.g. HDMI, USB-C...')
                        )}
                        {checkRow('charger','Charger (Specify Type)',
                          specifyInput('chargerType','e.g. MacBook 65W...')
                        )}
                        {checkRow('dockingStation','Docking Station',
                          <>{subCheck('dockingMac','Mac')}{subCheck('dockingWindows','Windows')}</>
                        )}
                        {checkRow('externalStorage','External Storage',
                          <>{subCheck('usbFlash','USB Flash Drive')}{subCheck('usbHardDrive','USB External Hard Drive')}</>
                        )}
                        {checkRow('monitor','Monitor',
                          <>{subCheck('monitorStandard','Standard')}{subCheck('monitorLarge','Large')}</>
                        )}
                        {checkRow('software','Software (Specify Type)',
                          specifyInput('softwareType','e.g. Adobe Creative Suite...')
                        )}
                        {checkRow('other','Other (Specify Type)',
                          specifyInput('otherType','Please describe...')
                        )}
                      </div>
                    </div>
                    {buildItemsList().length > 0 && (
                      <div style={{marginTop:12,padding:'10px 12px',background:'#fff',borderRadius:6,border:'1px solid #EDE6DA'}}>
                        <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:6}}>Selected Items</div>
                        {buildItemsList().map((item,i)=>(
                          <div key={i} style={{display:'flex',alignItems:'center',gap:6,fontSize:11,color:'#4A4A4A',marginBottom:3}}>
                            <div style={{width:5,height:5,borderRadius:'50%',background:accent,flexShrink:0}}></div>
                            {item}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Subject */}
                <div>
                  <label style={labelStyle}>Subject *</label>
                  <input value={form.subject} onChange={e=>setForm(f=>({...f,subject:e.target.value}))} placeholder="Brief description of your request" style={inputStyle}/>
                </div>

                {/* Description */}
                <div>
                  <label style={labelStyle}>Description *</label>
                  <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={3} placeholder="Please provide as much detail as possible..." style={{...inputStyle,resize:'vertical'}}/>
                </div>

                {/* Priority */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <div>
                    <label style={labelStyle}>Priority</label>
                    <select value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))} style={inputStyle}>
                      {['Low','Medium','High','Urgent'].map(p=><option key={p}>{p}</option>)}
                    </select>
                  </div>
                </div>

                {/* Funding Source + Approved By — required for equipment */}
                {isEquipment && (
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,padding:'14px',background:'rgba(74,107,138,0.04)',border:'1px solid rgba(74,107,138,0.15)',borderRadius:8}}>
                    <div>
                      <label style={{...labelStyle,color:'#4A6B8A'}}>Funding Source * <span style={{color:'#A0392B'}}>(required)</span></label>
                      <input value={form.fundingSource} onChange={e=>setForm(f=>({...f,fundingSource:e.target.value}))} placeholder="e.g. HR-ONBOARD-2025" style={{...inputStyle,borderColor:!form.fundingSource?'rgba(160,57,43,0.4)':'#EDE6DA'}}/>
                    </div>
                    <div>
                      <label style={{...labelStyle,color:'#4A6B8A'}}>Approved By * <span style={{color:'#A0392B'}}>(required)</span></label>
                      <input value={form.approvedBy} onChange={e=>setForm(f=>({...f,approvedBy:e.target.value}))} placeholder="Supervisor name" style={{...inputStyle,borderColor:!form.approvedBy?'rgba(160,57,43,0.4)':'#EDE6DA'}}/>
                    </div>
                  </div>
                )}

                {/* Additional notes */}
                <div>
                  <label style={labelStyle}>Additional Notes (optional)</label>
                  <textarea value={form.additionalNotes} onChange={e=>setForm(f=>({...f,additionalNotes:e.target.value}))} rows={2} placeholder="Any other information..." style={{...inputStyle,resize:'vertical'}}/>
                </div>

                <div style={{display:'flex',justifyContent:'flex-end',gap:10,paddingTop:4,borderTop:'1px solid #EDE6DA'}}>
                  <button onClick={()=>setActiveTab('my-tickets')} style={{padding:'8px 18px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                  <button onClick={handleSubmit} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Submit Request</button>
                </div>
              </div>
            )}
          </div>

          {/* Help sidebar */}
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B',marginBottom:12}}>Response Times</div>
              {[['Urgent','Within 2 hours','#A0392B'],['High','Within 4 hours','#C4843A'],['Medium','Within 1 business day','#4A6B8A'],['Low','Within 3 business days','#6B7D6B']].map(([p,t,c])=>(
                <div key={p} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 0',borderBottom:'1px solid #EDE6DA'}}>
                  <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,fontWeight:600,background:c+'22',color:c}}>{p}</span>
                  <span style={{fontSize:11,color:'#6B7D6B'}}>{t}</span>
                </div>
              ))}
            </div>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B',marginBottom:10}}>Tips</div>
              {['Be as specific as possible','Include error messages if applicable','Equipment requests require Funding Source and supervisor approval','For urgent issues call IT directly at ext. 204','IT will reach out to you directly after submission'].map((tip,i)=>(
                <div key={i} style={{display:'flex',gap:8,marginBottom:8,alignItems:'flex-start'}}>
                  <div style={{width:5,height:5,borderRadius:'50%',background:accent,flexShrink:0,marginTop:5}}></div>
                  <span style={{fontSize:11,color:'#6B7D6B',lineHeight:1.5}}>{tip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
